import { media, font, color } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../utilities/create/jss.js";
import "../node_modules/postcss/lib/postcss.js";
import "../node_modules/postcss-js/index.js";
import "../node_modules/postcss-nesting/dist/index.js";
import "../_virtual/index.js";
const breakpointLarge = media.queries.large.min;
const breakpointDesktop = media.queries.desktop.min;
const largeBase = {
  fontFamily: font.family["campaign"],
  fontSize: font.size["9xl"],
  fontWeight: font.weight["extraBold"],
  fontStyle: "italic",
  lineHeight: "1",
  [`@media (${breakpointDesktop})`]: {
    fontSize: "112px"
  }
};
const mediumBase = {
  fontFamily: font.family["campaign"],
  fontSize: font.size["7xl"],
  fontStyle: "italic",
  fontWeight: font.weight["extraBold"],
  lineHeight: "1",
  [`@media (${breakpointLarge})`]: {
    fontSize: `calc(${font.size["7xl"]} + 1.33vw)`
  },
  [`@media (${breakpointDesktop})`]: {
    fontSize: font.size["10xl"]
  }
};
const smallBase = {
  fontFamily: font.family["campaign"],
  fontSize: font.size["7xl"],
  fontStyle: "italic",
  fontWeight: font.weight["extraBold"],
  lineHeight: "0.87em"
};
function compose(size, options) {
  const { theme } = options || {};
  const sizes = {
    large: largeBase,
    medium: mediumBase,
    small: smallBase
  };
  const base = sizes[size];
  const composed = {
    ...base,
    ...theme && {
      color: theme === "dark" ? color.gold : color.red
    }
  };
  const classNameParts = ["umd-statistic-sans", size];
  if (theme === "dark") classNameParts.push("dark");
  return objectWithClassName({
    ...composed,
    className: classNameParts.join("-")
  });
}
const large = compose("large");
const medium = compose("medium");
const small = compose("small");
const fonts = {
  statLarge: compose("large"),
  statMedium: compose("medium"),
  statSmall: compose("small")
};
export {
  compose,
  fonts,
  large,
  medium,
  small
};
//# sourceMappingURL=stats.js.map
